<dashboardnav>
  <!-- <pre>{{stakeholders$ | async | json}}</pre> -->
    <cradua-stakeholderrep
    [stakeholderreps]="stakeholderreps$ | async"
    [stakeholders]="stakeholders$ | async"

    (changeEmit)="onSubmitStakeholderrep($event)"
    (deleteEvent)="onDeleteStakeholderrep($event)"
   
    
    *ngIf="
    !(isLoadingStakeholderrep$ | async ) &&
    !(isLoadingStakeholder$ | async )
    "
    >
  </cradua-stakeholderrep>

    <mrsoftapps-epims-reference-spinner
   
    *ngIf="
  (isLoadingStakeholderrep$ | async ) ||
  (isLoadingStakeholder$ | async )
  "
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
